import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BE_HOST } from "../../../config/config";
import { axiosInstance } from "../../../utils/axiosInterceptor";
const AdvanCapitalModal = ({
  isVisible,
  onClose,
  getQuarterlyData,
  targetPct,
  setIsInputColumnVisible,
  valuesAll,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  // console.log(valuesAll, "Valuesaslslsll");

  useEffect(() => {
    form.setFieldsValue(valuesAll);
  }, [valuesAll]);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto"; // Restore on unmount
    };
  }, [isVisible]);
  if (!isVisible) return null;

  const updateDetails = async (values) => {
    console.log(values, "Valuessss");
    getQuarterlyData(values?.genericRx, values?.BrandRx, targetPct);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content white-modal">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <h2 className="modal-title text-[#0EA5E9]">
          {/* <LockOutlined style={{ fontSize: 26, color: "#0EA5E9" }} /> */}
          <span className="ml-2">Advanced Calculator</span>
        </h2>

        <Form
          form={form}
          layout="vertical"
          onFinish={updateDetails}
          className="w-full max-w-md"
        >
          <Form.Item
            name="genericRx"
            label="Generic Rx Spend"
            rules={[
              { required: true, message: "Please Enter Generix Rx Spend" },
            ]}
          >
            <Input
              // prefix={<LockOutlined />}
              inputMode="numeric"
              placeholder="Generic Rx Spend"
              size="large"
              className="custom-input"
            />
          </Form.Item>

          <Form.Item
            name="BrandRx"
            label="Brand Rx Spend"
            rules={[{ required: true, message: "Please Enter Brand Rx Spend" }]}
          >
            <Input
              // prefix={<LockOutlined />}
              inputMode="numeric"
              placeholder="Brand Rx Spend"
              size="large"
              className="custom-input"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              className="custom-btn"
              loading={isLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AdvanCapitalModal;
